import React from 'react'
import { FormField, FormFieldLabel, Input, Modal, RadioButton, RadioButtonGroup } from '@vwfs-bronson/bronson-react'

export type RefundType = 'FULL' | 'PARTIAL';

interface InputModalInterface {
  message: string,
  showModal: boolean,
  title?: string,
  action?: string,
  handleOnClose: () => void
  handleOnConfirm: () => void,
  handleOnInputChange: (value) => void,
  defaultInputValue: number,
  inputValue: number,
  inputType: React.HTMLInputTypeAttribute,
  errorNotfication?: string,
  refundType?: RefundType,
  handleOnRefundTypeChange?: (refundType: RefundType) => void,
  commentValue?: string,
  handleOnCommentChange?: (comment: string) => void,
  testId?: string
}

export default function InputModal({ inputValue, errorNotfication, handleOnConfirm, showModal, handleOnClose, message, action, title, handleOnInputChange, inputType, defaultInputValue, refundType, handleOnRefundTypeChange, commentValue, handleOnCommentChange, testId }: InputModalInterface) {
  if (!message) {
    return null;
  }

  const renderMessage = () => {
    return (
      <>
        <p data-testid='test-modal-message'>
          {message}
        </p>
        {
          handleOnRefundTypeChange && (
            <RadioButtonGroup testId='testRefundTypeGroup'>
              <RadioButton
                testId='testFullRefundRadio'
                name='refundType'
                value='FULL'
                checked={refundType === 'FULL'}
                onChange={() => handleOnRefundTypeChange('FULL')}>
                Full Refund
              </RadioButton>
              <RadioButton
                testId='testPartialRefundRadio'
                name='refundType'
                value='PARTIAL'
                checked={refundType === 'PARTIAL'}
                onChange={() => handleOnRefundTypeChange('PARTIAL')}>
                Partial Refund
              </RadioButton>
            </RadioButtonGroup>
          )
        }
        <FormField
          labelForId="test-form-input"
          labelText="Enter amount for refund"
          type="input"
          testId='testInputText'
        >
          <Input
            id="test-refund-input"
            testId='testInputField'
            placeholder="Refund amount"
            noBackground
            onChange={e => handleOnInputChange(e.target.value)}
            defaultValue={defaultInputValue}
            value={inputValue}
            type={inputType}
            max={defaultInputValue}
            disabled={handleOnRefundTypeChange && refundType !== 'PARTIAL'}
          />
        </FormField>
        {
          handleOnCommentChange && (
            <FormField
              labelForId="test-refund-comment"
              labelText="Comment *"
              type="input"
              testId='testCommentText'
            >
              <Input
                id="test-refund-comment"
                testId='testCommentField'
                placeholder="Reason for the refund"
                noBackground
                type="text"
                value={commentValue || ''}
                onChange={e => handleOnCommentChange(e.target.value)}
              />
            </FormField>
          )
        }
        {
          errorNotfication && (
            <FormFieldLabel testId="errorTripsLabel" className='Error'>{errorNotfication}</FormFieldLabel>)
        }
      </>
    )
  }

  return <>
    <Modal
      shown={showModal}
      onClose={handleOnClose}
      onConfirm={handleOnConfirm}
      buttonConfirmLabel={action ? action : 'Ok'}
      buttonConfirmText={action ? action : 'Ok'}
      title={title ? title : `Action`}
      large={false}
      status='info'
      testId={testId ? testId : 'test-message-modal'}>
      {renderMessage()}
    </Modal>
  </>
}
